import { useContext, useEffect, useState } from "react";
import "../../Style/NewCompanyStyle.scss";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import axios from "axios";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import { errorAlert, handleSuccess } from "../../Components/Alerts";
import { FiscalYearContext } from "../../FiscalYear/FiscalYearContext";
// import {
//   LICENSE_TYPES,
//   PAYMENT_STATUS,
//   LICENSE_STATUS,
// } from "../../OtherData/LicenseData";
import { AddActionsButton } from "../../Components/AddElementsButton";
import { FaTimes } from "react-icons/fa";
import { getSystemPackage } from "../../GetData/SystemPackage";
import { getSystemModules } from "../../GetData/SystemModules";
import { getLicenseStatus } from "../../GetData/LicenseStatus";
import { getSystemLicenseTypes } from "../../GetData/LicenseType";
import { getLicensePaymentStatus } from "../../GetData/LicensePaymentType";

export default function NewLicens() {
  const headers = authHeader();
  // const year = new Date().getFullYear();
  const { fiscalYear } = useContext(FiscalYearContext);
  const [module, setModule] = useState([]);

  const [disableForm, setDisableForm] = useState(false);
  const [step, setStep] = useState(2);
  const [loading, setLoading] = useState(false);
  // Company states
  const [identificationNumber, setIdentificationNumber] = useState("");

  // License states
  const [licenseTypeID, setLicenseTypeID] = useState();
  const [packageID, setPackageID] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState("");
  const [statusID, setStatusID] = useState("");
  const [paymentStatusID, setPaymentStatusID] = useState("");
  const [licenseComment, setLicenseComment] = useState("");

  const [pack, setPack] = useState([]);
  const [company, setCompany] = useState([]);

  const [accountantUser, setAccountantUser] = useState([]);

  const [accountantUserID, setAccountantUserID] = useState("");
  const [ipAddress, setIpAddress] = useState("");
  const [userComment, setUserComment] = useState("");

  const [licenseTypes, setLicenseTypes] = useState([]);
  const [licensesStatus, setLicensesStatus] = useState([]);
  const [licensePaymentType, setLicensePaymentType] = useState([]);

  //Pjesa per select input field city
  const [companyName, setCompanyName] = useState("");
  const handleAutocompleteChangeCompany = (event, value) => {
    if (value && value.CompanyID) {
      setIdentificationNumber(value.IdentificationNumber);
      setCompanyName(value);
    } else {
      // Në rast se vlera është pastruar
      setIdentificationNumber(""); // Vendos vlerën e ArticleID në null
    }
  };

  const defaultPropsCompany = {
    options: company,
    getOptionLabel: (option) =>
      `${option.IdentificationNumber} - ${option.CompanyName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            {option.IdentificationNumber}
            <br />
            {option.CompanyName}{" "}
          </span>
        </li>
      </>
    ),
  };

  // const completeData = (id) => {
  //   if (id === 4) {
  //     setStatusID(4);
  //     setPaymentStatusID(4);
  //   } else if (id === 5) {
  //     setStatusID(5);
  //     setPaymentStatusID(5);
  //   }
  // };

  //Pjesa per select input field licenseType
  const [licenseType, setLiceseType] = useState(null);
  const handleAutocompleteChangeLicenseType = (event, value) => {
    if (value && value.DurationTypeID) {
      setLicenseTypeID(value.DurationTypeID);
      setLiceseType(value);
      // kalkulo endDate automatikisht
      const calculatedEnd = calculateEndDate(value.DurationDays);
      setEndDate(calculatedEnd);
      // completeData(value.DurationTypeID);
    } else {
      // nëse pastrohet
      setLicenseTypeID("");
      setLiceseType(null);
      setEndDate("");
    }
  };

  const defaultPropsLicenseType = {
    options: licenseTypes,
    getOptionLabel: (option) => `${option.DurationName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            {option.DurationName}
            <br />
          </span>
        </li>
      </>
    ),
  };

  //Pjesa per select input field licenseStatus
  const [licenseStatus, setLiceseStatus] = useState(null);
  const handleAutocompleteChangeLicenseStatus = (event, value) => {
    if (value && value.LicenseStatusID) {
      setStatusID(value.LicenseStatusID);
      setLiceseStatus(value);
    } else {
      // Në rast se vlera është pastruar
      setStatusID(""); // Vendos vlerën e ArticleID në null
    }
  };

  const defaultPropsLicenseStatus = {
    options: licensesStatus,
    getOptionLabel: (option) => `${option.StatusName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            {option.StatusName}
            <br />
          </span>
        </li>
      </>
    ),
  };

  //Pjesa per select input field paymentStatus
  const [paymentStatus, setPaymentStatus] = useState("");
  const handleAutocompleteChangePaymentStatus = (event, value) => {
    if (value && value.PaymentStatusID) {
      setPaymentStatusID(value.PaymentStatusID);
      setPaymentStatus(value);
    } else {
      // Në rast se vlera është pastruar
      setPaymentStatusID(""); // Vendos vlerën e ArticleID në null
    }
  };

  const defaultPropsPaymentStatus = {
    options: licensePaymentType,
    getOptionLabel: (option) => `${option.StatusName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            {option.StatusName}
            <br />
          </span>
        </li>
      </>
    ),
  };

  //Pjesa per select input field pack
  const [packageType, setPackageType] = useState(null);
  const [packageField, setPackageField] = useState(null);
  const handleAutocompleteChangePackageType = (event, value) => {
    if (value && value.PackageID) {
      setPackageID(value.PackageID);
      setPackageType(value.PackageName);
      setPackageField(value);
    } else {
      // Në rast se vlera është pastruar
      setLicenseTypeID(""); // Vendos vlerën e ArticleID në null
    }
  };

  const defaultPropsPackageType = {
    options: pack,
    getOptionLabel: (option) => `${option.PackageName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            {option.PackageName}
            <br />
          </span>
        </li>
      </>
    ),
  };

  //Pjesa per select input field module
  const [moduleType, setModuleType] = useState(null);
  const [moduleField, setModuleField] = useState(null);
  const handleAutocompleteChangeModuleType = (event, value) => {
    if (value && value.ModuleID) {
      //   setModuleID(value.PackID);
      setModuleType(value.ModuleCode);
      setModuleField(value);
    } else {
      // Në rast se vlera është pastruar
      //   setModuleID(""); // Vendos vlerën e ArticleID në null
    }
  };

  const defaultPropsModuleType = {
    options: module,
    getOptionLabel: (option) => `${option.ModuleName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            {option.ModuleName}
            <br />
          </span>
        </li>
      </>
    ),
  };

  //Pjesa per select input field users
  const [userName, setUserName] = useState("");
  const handleAutocompleteChangeUser = (event, value) => {
    if (value && value.Id) {
      setAccountantUserID(value.Id);
      setUserName(value);
    } else {
      // Në rast se vlera është pastruar
      setAccountantUserID(""); // Vendos vlerën e ArticleID në null
    }
  };

  const defaultPropsUser = {
    options: accountantUser,
    getOptionLabel: (option) => `${option.UserName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            {option.UserName}
            <br />
          </span>
        </li>
      </>
    ),
  };

  const handleSubmitLicense = (event) => {
    event.preventDefault();
    setLoading(true);

    const stateData = {
      LicenseTypeID: licenseTypeID,
      PackageID: packageID,
      StartDate: startDate,
      EndDate: endDate,
      Status: statusID,
      PaymentStatus: paymentStatusID,
      Comment: licenseComment,
    };

    axios
      .post(ApiLink.API_URL + "License/newLicense", stateData, {
        headers,
        params: { identificationNumber: identificationNumber },
      })
      .then((response) => {
        handleSuccess("Licensa u gjenerua me sukses");
        setLoading(false);
        handleUpdateCompanyPack();
        if (licenseTypeID === 5) {
          setStep(3); // Move to accountant Form
        } else {
          setStep(4); // Move to final Form
        }
      })
      .catch((error) => {
        setLoading(false);
        setDisableForm(false);
        if (error.response) {
          // Server ktheu një përgjigje (jo 2xx)
          if (error.response.data) {
            errorAlert(
              `Gabim nga serveri: ${error.response.status}\n` +
                `Detaje: ${JSON.stringify(error.response.data)}`
            );
          } else {
            errorAlert(`Gabim nga serveri: ${error.response.status}`);
          }
        } else if (error.request) {
          // Request u dërgua, por nuk erdhi përgjigje
          errorAlert("Serveri nuk u përgjigj fare. Kontrollo lidhjen.");
        } else {
          // Error tjetër në konfigurim ose ekzekutim
          errorAlert("Gabim gjatë konfigurimit të kërkesës: " + error.message);
        }
      });
  };

  const handleUpdateCompanyPack = () => {
    const updateData = {
      Pack: packageType,
      Module: moduleType,
    };

    // axios.put(ApiLink.API_URL + 'PackContoller', updateData, { headers })
    axios
      .put(ApiLink.API_URL + "PackContoller/packForCompany", updateData, {
        headers,
        params: { identificationNumber: identificationNumber },
      })
      .then((response) => {
        if (response.status === 200) {
          setDisableForm(true);
          // handleSuccess(response.data); // Shfaq mesazhin e suksesit
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 400) {
            errorAlert(
              "Të dhënat janë të pavlefshme. Ju lutem kontrolloni dhe provoni përsëri."
            );
          } else if (error.response.status === 500) {
            errorAlert("Gabim serveri. Ju lutem provoni më vonë.");
          } else {
            errorAlert("Gabim i panjohur: " + error.response.data);
          }
        } else {
          errorAlert(
            "Nuk mund të lidhemi me serverin. Ju lutem provoni më vonë."
          );
        }
      });
  };

  const handleSubmitAccountant = (event) => {
    event.preventDefault();
    setLoading(true);

    const stateData = {
      UserID: accountantUserID,
      IPAddress: ipAddress,
      Comment: userComment,
    };

    axios
      .post(ApiLink.API_URL + "License/newFreeManagementAccount", stateData, {
        headers,
        params: { identificationNumber: identificationNumber },
      })
      .then((response) => {
        handleSuccess("Llogaria u shtua tek lista e kontabilistit");
        setStep(4); // Move to final Form
      })
      .catch((error) => {
        setLoading(false);
        if (error.response) {
          // Server ktheu një përgjigje (jo 2xx)
          if (error.response.data) {
            errorAlert(
              `Gabim nga serveri: ${error.response.status}\n` +
                `Detaje: ${JSON.stringify(error.response.data)}`
            );
          } else {
            errorAlert(`Gabim nga serveri: ${error.response.status}`);
          }
        } else if (error.request) {
          // Request u dërgua, por nuk erdhi përgjigje
          errorAlert("Serveri nuk u përgjigj fare. Kontrollo lidhjen.");
        } else {
          // Error tjetër në konfigurim ose ekzekutim
          errorAlert("Gabim gjatë konfigurimit të kërkesës: " + error.message);
        }
      });
  };

  useEffect(() => {
    axios
      .get(ApiLink.API_URL + "Companies/companyWithoutLicense", { headers })
      .then((response) => {
        setCompany(response.data);
      })
      .catch((error) => {
        errorAlert("Gabim gjate marrjes se te dhenave");
      });
  }, [disableForm]);

  const fetchUser = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Users/getAccountantUser",
        { headers }
      );
      setAccountantUser(response.data);
      setLoading(false);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);

      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const calculateEndDate = (durationDays) => {
    // startDate është gjithmonë data e sotme
    const start = new Date();

    // endDate = startDate + durationDays
    const end = new Date(start);
    end.setDate(start.getDate() + Number(durationDays));

    // kthe format YYYY-MM-DD
    return end.toISOString().split("T")[0];
  };

  // const calculateEndDate = (type) => {
  //   const today = new Date(startDate);
  //   const end = new Date(today);

  //   switch (type) {
  //     case "trial":
  //     case "weekly":
  //       end.setDate(today.getDate() + 7);
  //       break;
  //     case "monthly":
  //       end.setMonth(today.getMonth() + 1);
  //       break;
  //     case "yearly":
  //     case "accountant":
  //       end.setFullYear(today.getFullYear() + 1);
  //       break;
  //     default:
  //       end.setDate(today.getDate());
  //   }
  //   return end.toISOString().split("T")[0]; // format YYYY-MM-DD
  // };

  useEffect(() => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;

    if (fiscalYear === year) {
      setStartDate(formattedDate);
    } else {
      setStartDate("");
    }
  }, [fiscalYear]);

  // const fetchPack = async () => {
  //   try {
  //     const response = await axios.get(ApiLink.API_URL + "PackContoller", {
  //       headers,
  //       params: { type: "pako" },
  //     });
  //     setPack(response.data);
  //     setLoading(false);
  //   } catch (error) {
  //     errorAlert("Gabim në kërkesë:", error);

  //     if (
  //       error.response &&
  //       error.response.data &&
  //       error.response.data.errorMessage
  //     ) {
  //       errorAlert(
  //         `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`
  //       );
  //     } else if (error.message) {
  //       errorAlert(`Gabim: ${error.message}`);
  //     } else {
  //       errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
  //     }
  //   }
  // };

  // const fetchModule = async () => {
  //   try {
  //     const response = await axios.get(ApiLink.API_URL + "PackContoller", {
  //       headers,
  //       params: { type: "modul" },
  //     });
  //     setModule(response.data);
  //     setLoading(false);
  //   } catch (error) {
  //     errorAlert("Gabim në kërkesë:", error);

  //     if (
  //       error.response &&
  //       error.response.data &&
  //       error.response.data.errorMessage
  //     ) {
  //       errorAlert(
  //         `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`
  //       );
  //     } else if (error.message) {
  //       errorAlert(`Gabim: ${error.message}`);
  //     } else {
  //       errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
  //     }
  //   }
  // };

  const cleanForm = (e) => {
    e.preventDefault();

    setDisableForm(false);
    setLoading(false);
    setIdentificationNumber("");
    setLicenseTypeID("");
    setPackageID("");
    setStartDate(new Date());
    setEndDate("");
    setStatusID("");
    setPaymentStatusID("");
    setLicenseComment("");

    setCompanyName("");
    setLiceseType("");
    setLiceseStatus(null);
    setPaymentStatus("");
    setPackageType(null);
    setPackageField(null);
    setModuleType(null);
    setModuleField(null);
    setStep(2);
  };

  const loaddata = async () => {
    try {
      const [
        packagesType,
        modules,
        licenseType,
        licenseStatus,
        licensePaymentType,
      ] = await Promise.all([
        getSystemPackage(headers),
        getSystemModules(headers),
        getSystemLicenseTypes(headers),
        getLicenseStatus(headers),
        getLicensePaymentStatus(headers),
      ]);

      if (packagesType) setPack(packagesType);
      if (modules) setModule(modules);
      if (licenseType) setLicenseTypes(licenseType);

      console.log(licenseType);
      if (licenseStatus) setLicensesStatus(licenseStatus);
      if (licensePaymentType) setLicensePaymentType(licensePaymentType);
    } catch (error) {}
  };

  useEffect(() => {
    fetchUser();
    // fetchPack();
    // fetchModule();
    loaddata();
  }, []);

  return (
    <div className="form-container">
      {/* te dhenat e licenses se kompnanis */}
      {step == 2 && (
        <form className="card" onSubmit={handleSubmitLicense}>
          <h2>Gjenerimi i Licensës</h2>
          <p style={{ color: "red" }}>
            Këtu mund të gjeneroni licensa vetëm për kompanitë që nuk kanë fare
            licensë ose nëse licensa e tyre ka skaduar
          </p>

          <div className="form-grid">
            <div className="form-grid-fields">
              <Autocomplete
                className="class__Fields"
                {...defaultPropsCompany}
                id="include-input-in-list"
                includeInputInList
                value={companyName}
                getOptionLabel={(option) => option.CompanyName || ""}
                onChange={handleAutocompleteChangeCompany}
                autoComplete="off"
                disabled={disableForm}
                // isOptionEqualToValue={(option, value) => option.StateID === value.StateID} // Shto funksionin isOptionEqualToValue
                renderInput={(params) => (
                  <TextField
                    // style={{ width: "95%" }}
                    {...params}
                    label="Zgjedheni kompanin"
                    autoComplete="off"
                    disabled={disableForm}
                    // variant="filled"
                    //   onKeyPress={handleKeyPress}
                  />
                )}
              />

              <Autocomplete
                className="class__Fields"
                {...defaultPropsLicenseType}
                id="include-input-in-list"
                includeInputInList
                value={licenseType}
                isOptionEqualToValue={(option, value) =>
                  option.DurationTypeID === value?.DurationTypeID
                }
                onChange={handleAutocompleteChangeLicenseType}
                autoComplete="off"
                disabled={disableForm}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Zgjedh Llojin e licenses"
                    autoComplete="off"
                    disabled={disableForm}
                  />
                )}
              />
            </div>
            <div className="form-grid-fields">
              <TextField
                className="class__Fields"
                id="date"
                type="date"
                variant="outlined"
                name="Date"
                label="Data fillimit"
                value={startDate}
                disabled={disableForm}
                onChange={(e) => setStartDate(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                // inputProps={{
                //     min: minDate, // Kufizimi minimal i datës
                //     max: maxDate, // Kufizimi maksimal i datës
                // }}
              />

              <TextField
                className="class__Fields"
                id="date"
                type="date"
                variant="outlined"
                name="Date"
                label="Data mbarimit"
                value={endDate}
                disabled={disableForm}
                onChange={(e) => {
                  setEndDate(e.target.value);
                }}
                // disabled={form1IsDisabled}
                InputLabelProps={{
                  shrink: true,
                }}
                // inputProps={{
                //     min: minDate, // Kufizimi minimal i datës
                //     max: maxDate, // Kufizimi maksimal i datës
                // }}
              />
            </div>
            <div className="form-grid-fields">
              <Autocomplete
                className="class__Fields"
                {...defaultPropsPackageType}
                id="include-input-in-list"
                includeInputInList
                value={packageField}
                disabled={disableForm}
                getOptionLabel={(option) => option.PackageName || ""}
                onChange={handleAutocompleteChangePackageType}
                autoComplete="off"
                // isOptionEqualToValue={(option, value) => option.StateID === value.StateID} // Shto funksionin isOptionEqualToValue
                renderInput={(params) => (
                  <TextField
                    // style={{ width: "95%" }}
                    {...params}
                    label="Zgjedh Llojin e Pakos"
                    autoComplete="off"
                    disabled={disableForm}

                    // variant="filled"
                    //   onKeyPress={handleKeyPress}
                  />
                )}
              />
              <Autocomplete
                className="class__Fields"
                {...defaultPropsModuleType}
                id="include-input-in-list"
                includeInputInList
                value={moduleField}
                getOptionLabel={(option) => option.ModuleName || ""}
                disabled={disableForm}
                onChange={handleAutocompleteChangeModuleType}
                autoComplete="off"
                // isOptionEqualToValue={(option, value) => option.StateID === value.StateID} // Shto funksionin isOptionEqualToValue
                renderInput={(params) => (
                  <TextField
                    // style={{ width: "95%" }}
                    {...params}
                    label="Zgjedh Modulin"
                    autoComplete="off"
                    disabled={disableForm}

                    // variant="filled"
                    //   onKeyPress={handleKeyPress}
                  />
                )}
              />
            </div>
            <div className="form-grid-fields">
              <Autocomplete
                className="class__Fields"
                {...defaultPropsLicenseStatus}
                id="include-input-in-list"
                includeInputInList
                // value={licenseStatus}
                value={
                  licensesStatus.find(
                    (option) => option.LicenseStatusID === statusID
                  ) || licenseStatus
                }
                getOptionLabel={(option) => option.StatusName || ""}
                onChange={handleAutocompleteChangeLicenseStatus}
                autoComplete="off"
                disabled={disableForm}
                // isOptionEqualToValue={(option, value) => option.StateID === value.StateID} // Shto funksionin isOptionEqualToValue
                renderInput={(params) => (
                  <TextField
                    // style={{ width: "95%" }}
                    {...params}
                    label="Statusi i licenses"
                    autoComplete="off"
                    disabled={disableForm}

                    // variant="filled"
                    //   onKeyPress={handleKeyPress}
                  />
                )}
              />

              <Autocomplete
                className="class__Fields"
                {...defaultPropsPaymentStatus}
                id="include-input-in-list"
                includeInputInList
                // value={paymentStatus}
                value={
                  licensePaymentType.find(
                    (option) => option.PaymentStatusID === paymentStatusID
                  ) || paymentStatus
                }
                getOptionLabel={(option) => option.StatusName || ""}
                onChange={handleAutocompleteChangePaymentStatus}
                autoComplete="off"
                disabled={disableForm}
                // isOptionEqualToValue={(option, value) => option.StateID === value.StateID} // Shto funksionin isOptionEqualToValue
                renderInput={(params) => (
                  <TextField
                    // style={{ width: "95%" }}
                    {...params}
                    label="Statusi i pagesës"
                    autoComplete="off"
                    disabled={disableForm}

                    // variant="filled"
                    //   onKeyPress={handleKeyPress}
                  />
                )}
              />
            </div>
            <label>
              Përshkrim
              <textarea
                value={licenseComment}
                onChange={(e) => setLicenseComment(e.target.value)}
                rows="2"
              />
            </label>
          </div>
          <button type="submit" disabled={loading}>
            {loading ? "Duke u procesuar" : "Gjenero licensen"}
          </button>
        </form>
      )}
      {/* te dhenat per kontabilist */}
      {step === 3 && (
        <form className="card" onSubmit={handleSubmitAccountant}>
          <h2>Informata për kontabilistin</h2>
          <div className="form-grid">
            <div className="form-grid-fields">
              <Autocomplete
                className="class__Fields"
                {...defaultPropsUser}
                id="include-input-in-list"
                includeInputInList
                value={userName}
                getOptionLabel={(option) => option.UserName || ""}
                onChange={handleAutocompleteChangeUser}
                autoComplete="off"
                // isOptionEqualToValue={(option, value) => option.StateID === value.StateID} // Shto funksionin isOptionEqualToValue
                renderInput={(params) => (
                  <TextField
                    // style={{ width: "95%" }}
                    {...params}
                    label="Zgjedh përdoruesin"
                    autoComplete="off"

                    // variant="filled"
                    //   onKeyPress={handleKeyPress}
                  />
                )}
              />

              <TextField
                className="class__Fields"
                id="outlined-required"
                label="IP Adresa"
                value={ipAddress}
                onChange={(event) => setIpAddress(event.target.value)}
                autoComplete="off"
              />
            </div>
            <label>
              Përshkrim
              <textarea
                value={userComment}
                onChange={(e) => setUserComment(e.target.value)}
                rows="2"
              />
            </label>
          </div>
          <button type="submit" disabled={loading}>
            {loading ? "Duke u procesuar..." : "Ruaj"}
          </button>
        </form>
      )}
      {/* perfundimi */}
      {step === 4 && (
        <form className="card" onSubmit={handleSubmitLicense}>
          <h2>Licensa u krijua, krijo licens të re duke klikuar ne buton</h2>
          <AddActionsButton
            text="Krijo licens të re"
            icon={<FaTimes />}
            onClick={(e) => cleanForm(e)}
          />
        </form>
      )}
    </div>
  );
}
